

















import { defineComponent, ref } from "@vue/composition-api";
import { focusNext } from "@/lib/formHelpers";
import { $t } from "@/lib/i18nHelpers";
import { FormField, FormFields, FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "CardDetailsForm",
  components: { BaseForm },
  model: {
    event: "input",
    prop: "values",
  },
  props: {
    values: { type: Object as () => FormValues, required: true },
  },
  setup(_, { emit }) {
    const fields = ref<FormFields>([
      {
        name: "cardNumber",
        label: $t("Card number"),
        placeholder: $t("Card number"),
        fieldClass: "inline-field",
        prependIcon: "sci-credit-card-outline",
        prependIconColor: "var(--palette-gray)",
        pattern: "\\d*",
        type: "tel",
        rules: ["required", "credit_card"],
        maxlength: "16",
        hideErrorMessage: true,
        hideLabel: true,
      },
      {
        name: "expireDate",
        label: $t("Expire date"),
        placeholder: "MM/YY",
        fieldClass: "inline-field px-0",
        pattern: "\\d*",
        type: "tel",
        rules: ["required", "credit_card_expire"],
        maskOpts: {
          showMaskOnFocus: false,
          showMaskOnHover: false,
          regex: "\\d{2}/\\d{2}",
        },
        hideErrorMessage: true,
        hideLabel: true,
      },
      {
        name: "cvc",
        label: $t("CVC"),
        placeholder: "CVC",
        fieldClass: "inline-field",
        pattern: "\\d*",
        type: "tel",
        rules: ["required", "max:4", "min:3", "numeric"],
        hideErrorMessage: true,
        hideLabel: true,
      },
      {
        name: "nameOnCard",
        label: $t("Name on card"),
        rules: ["required", "alpha_spaces"],
        hideErrorMessage: true,
      },
    ]);
    const onFormInput = (v: FormValues, e: InputEvent, field: FormField) => {
      const target = e.target as HTMLInputElement;
      if (
        (field.name === "cardNumber" && target.value.length === 16) ||
        (field.name === "expireDate" && target.value.replace(/\/|_/g, "").length === 4) ||
        (field.name === "cvc" && target.value.length === 3)
      ) {
        focusNext(target.value, target);
      }
      emit("input", v);
    };

    const getFirstErrorMessage = (errors: Record<string, string[]>) => {
      const error = Object.entries(errors).find(error => error[1].length > 0);
      return error ? error[1][0] : "";
    };

    return {
      fields,
      onFormInput,
      getFirstErrorMessage,
    };
  },
});
